const getters = {
    token: state => state.user.token,
    name: state => state.user.name,
    realName: state => state.user.realName
  }
  export default getters
  